import dayjs from "dayjs";
import { useState } from "react";
import { Button, Col, Form, Spinner } from "react-bootstrap";
import { toast } from "react-toastify";
import { getValueFromInput, getValueFromInputCheck } from "../../../components/funcForInput";
import { ApiEndpoints, reqPost, reqPostDownloadFile } from "../../../config/apiClient";

export default function FormDownloadRelatorioPonto({ apuracao }: iProps) {
    const [loading, setLoading] = useState<boolean>(false);
    const [downloadProgress, setDownloadProgress] = useState<number>(0);

    async function download() {
        setLoading(true);
        setDownloadProgress(0);

        let ids_colaboradores = parseColaboradores(apuracao);
        let arquivos = [];
        let erro = false;
        const apenas_totais = getValueFromInputCheck("apenas_totais") === true ? 1 : 0

        if (apenas_totais === 1) { 
            let dadosAux:any = {
                ids_colaborador: ids_colaboradores,
                data_inicial: getValueFromInput("data_inicial"),
                data_final: getValueFromInput("data_final"),
                formato: getValueFromInput("formato"),
                apenas_totais: getValueFromInputCheck("apenas_totais") === true ? 1 : 0,
                mostrar_totais: getValueFromInputCheck("mostrar_totais") === true ? 1 : 0,
            }
            console.log(dadosAux)
            let arquivo:string = ''
            arquivo = `Totais-Folha-Ponto-${dayjs(dadosAux.data_inicial).format("MM-YYYY")}.${dadosAux.formato === 'pdf' ? 'pdf' : 'xlsx'}`
            setDownloadProgress(50);
            let response = await reqPostDownloadFile(ApiEndpoints.apuracaoCalcularDadosTotaisDownload, dadosAux, arquivo)
            if (response.status === 200) {
                setDownloadProgress(100);
                toast.success('Aguarde o termino do download...', {
                    containerId: 1,
                    position: 'top-center',
                    theme: 'dark'
                })
            } else {
                toast.error('Erro no download, tente mais tarde ou verifique com o suporte!', {
                    containerId: 1,
                    position: 'top-center',
                    theme: 'dark'
                })
            }
    
            setLoading(false)
            setDownloadProgress(0);
            return
        }
        
        for (let index = 0; index < ids_colaboradores.length; index++) {
            const id_colaborador = ids_colaboradores[index];
            let dadosAux: any = {
                id_colaborador: id_colaborador,
                data_inicial: getValueFromInput("data_inicial"),
                data_final: getValueFromInput("data_final"),
                formato: getValueFromInput("formato"),
                apenas_totais: getValueFromInputCheck("apenas_totais") === true ? 1 : 0,
                mostrar_totais: getValueFromInputCheck("mostrar_totais") === true ? 1 : 0,
            };
            console.log(dadosAux);
            if (ids_colaboradores.length === 1) {
                let arquivo: string = "";
                if (dadosAux.apenas_totais === 1) {
                    arquivo = `Totais-Folha-Ponto-${dayjs(dadosAux.data_inicial).format("MM-YYYY")}.${dadosAux.formato === "pdf" ? "pdf" : "xlsx"}`;
                    dadosAux.id_colaborador = dadosAux.id_colaborador.toString();
                }
                if (dadosAux.apenas_totais === 0) {
                    let colaborador = apuracao.filter((reg: any) => reg.id_colaborador === dadosAux.id_colaborador)[0];
                    arquivo = `Folha-Ponto-${colaborador.colaborador}-${dayjs(dadosAux.data_inicial).format("MM-YYYY")}.${dadosAux.formato === "pdf" ? "pdf" : "xlsx"}`;
                }
                let response = await reqPostDownloadFile(ApiEndpoints.apuracaoCalcularDadosDownload, dadosAux, arquivo);
                if (response.status === 200) {
                    toast.success("Aguarde o termino do download...", {
                        containerId: 1,
                        position: "top-center",
                        theme: "dark",
                    });
                } else {
                    toast.error("Erro no download, tente mais tarde ou verifique com o suporte!", {
                        containerId: 1,
                        position: "top-center",
                        theme: "dark",
                    });
                }
                setLoading(false);
                return;
            }

            let api = await reqPost(ApiEndpoints.apuracaoCalcularDadosDownloadPath, dadosAux);
            if (api.status === 200) {
                arquivos.push(api.data.message);
                setDownloadProgress(Math.round((index + 1) / ids_colaboradores.length * 80));
            } else {
                console.log(api);
                if (api.status === 400) {
                    toast.error(api.data.message, {
                        containerId: 1,
                        position: "top-center",
                        theme: "dark",
                    });
                } else {
                    toast.error("Erro no download, tente mais tarde ou verifique com o suporte!", {
                        containerId: 1,
                        position: "top-center",
                        theme: "dark",
                    });
                }
                erro = true;
                break;
            }
        }
        if (erro) {
            setLoading(false);
            return;
        }

        let dadosAux: any = {
            paths: arquivos,
        };
        let arquivo: string = "";
        arquivo = `Folhas-Ponto-${dayjs(getValueFromInput("data_inicial")).format("MM-YYYY")}.zip`;
        setDownloadProgress(90);
        let response = await reqPostDownloadFile(ApiEndpoints.apuracaoCalcularDadosDownloadVarios, dadosAux, arquivo);
        if (response.status === 200) {
            setDownloadProgress(100);
            toast.success("Aguarde o termino do download...", {
                containerId: 1,
                position: "top-center",
                theme: "dark",
            });
        } else {
            toast.error("Erro no download, tente mais tarde ou verifique com o suporte!", {
                containerId: 1,
                position: "top-center",
                theme: "dark",
            });
        }

        setLoading(false);
        setDownloadProgress(0);
    }

    function parseColaboradores(dados: any[]) {
        let ids: number[] = [];
        for (let reg of dados) {
            ids.push(reg.id_colaborador);
        }
        return ids;
    }

    return (
        <div>
            <br />
            <p>Colaboradores Selecionados ({apuracao.length})</p>
            <br></br>
            <div className="div-row">
                <Col className="col-4">
                    <Form.Group>
                        <Form.Label>Formato de Dados:</Form.Label>
                        <Form.Select name="formato" id="formato" aria-label="Selecione o Formato">
                            <option value="pdf">PDF</option>
                            <option value="excel">Excel</option>
                        </Form.Select>
                    </Form.Group>
                </Col>
            </div>
            <br></br>
            <div className="div-row">
                <Col className="col-4">
                    <div>
                        <label style={{ marginRight: "10px" }}>Mostrar calculo de Horas?</label>
                        <input name="mostrar_totais" type="checkbox" id="mostrar_totais" defaultChecked />
                    </div>
                </Col>
                <Col className="col-4">
                    <div>
                        <label style={{ marginRight: "10px" }}>Relatório apenas com totais?</label>
                        <input name="apenas_totais" type="checkbox" id="apenas_totais" />
                    </div>
                </Col>
            </div>
            <br />
            <div className="div-row">
                <Button type="submit" variant="success" disabled={loading} style={{ marginRight: "5px" }} onClick={(e) => download()}>
                    {loading ? "Aguarde..." : "Download"}
                </Button>
            </div>
            <br></br>
            {loading && (
                <div className="div-row" style={{ alignItems: "center", gap: "10px" }}>
                    <Spinner />
                    <span style={{ fontSize: "14px", color: "#6c757d" }}>
                        Baixando {downloadProgress}%
                    </span>
                </div>
            )}
        </div>
    );
}
interface iProps {
    apuracao: any;
}
